import { useOutletContext } from 'react-router-dom';
import type { ApiClient } from '../api.js';

export interface OutletCtx {
  api: ApiClient;
}

export function useApi(): ApiClient {
  return useOutletContext<OutletCtx>().api;
}
